export const FINDER_CURSOR_PAGE_SIZE = 200;
